import type { ButtonHTMLAttributes } from 'react';
import { Plus } from 'lucide-react';
import styles from './AddLinkFAB.module.css';

interface AddLinkFABProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  onClick: () => void;
}

export const AddLinkFAB = ({
  onClick,
  className = '',
  ...props
}: AddLinkFABProps) => {
  const classNames = [styles.fab, className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      aria-label="Add link"
      {...props}
    >
      <Plus className={styles.icon} size={28} strokeWidth={2.5} />
    </button>
  );
};

